import { useEffect } from 'react'

import { EVENT_NAME_MOUSE_DOWN } from '../constants/event'
import { HTML_DATA_PARAM_OUTSIDE_TRIGGER } from '../constants/html'

export function useMouseDownOutside(ref, onMouseDownOut, parent) {
  useEffect(() => {
    if (ref?.current || onMouseDownOut) {
      function handleMouseDown(event) {
        // WARNING! This case must be exceptable to use!
        // Need for case if container with `onClick` has child element
        // that should work like click outside.
        // For example `EmailRecipientsField`
        if (event.target.closest(`[${HTML_DATA_PARAM_OUTSIDE_TRIGGER}]`)) {
          onMouseDownOut()
        }

        if (parent?.current && parent.current.contains(event.target)) {
          return
        }

        if (ref.current && !ref.current.contains(event.target)) {
          onMouseDownOut()
        }
      }

      document.addEventListener(EVENT_NAME_MOUSE_DOWN, handleMouseDown)

      return function cleanup() {
        document.removeEventListener(EVENT_NAME_MOUSE_DOWN, handleMouseDown)
      }
    }
  }, [onMouseDownOut, ref])
}
